import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function CancellationPolicy() {
  const navigate = useNavigate();
  const location = useLocation();
  const bookingIndex = location.state?.index;

  const handleConfirmCancel = () => {
    const history = JSON.parse(localStorage.getItem("bookingHistory")) || [];
    const updated = history.filter((_, i) => i !== bookingIndex);
    localStorage.setItem("bookingHistory", JSON.stringify(updated));
    alert("Booking has been cancelled.");
    navigate("/my-booking"); // Go back to MyBooking page
  };

  return (
    <div style={{ padding: 40 }}>
        {/* 👇 Paste this "X" button here */}
    <button
      onClick={() => navigate("/my-booking")}
      style={{
        position: "absolute",
        top: 10,
        right: 10,
        background: "transparent",
        border: "none",
        fontSize: "24px",
        fontWeight: "bold",
        cursor: "pointer"
      }}
    >
      X
    </button>
      <h2>Cancellation Policy</h2>
      <p>
       <div style={{ fontWeight: "bold", fontSize: "22px", marginBottom: "8px" }}>
      Please read before cancelling:
    </div>
        <ul>
          <li>Free cancellation if done more than 12 hours before the scheduled service or if a professional has not been assigned.</li>
          <li>A cancellation fee of ₹100 will apply if cancelled within 12 hours of the service time..</li>
          <li>A cancellation fee of ₹200 will apply if cancelled within 3 hours of the service time..</li>
          <li>No cancellation fee if a professional has not been assigned.</li>
        </ul>
      </p>
      <button
        onClick={handleConfirmCancel}
        style={{ marginTop: 20, padding: "10px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "6px" }}
      >
        Yes, Cancel My Booking
      </button>
    </div>
  );
}
